import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Category } from 'src/app/cards/category/category.model';
import { CategoryService } from 'src/app/cards/category/category.service';
import { Product } from 'src/app/cards/product/product.model';
import { ProductService } from 'src/app/cards/product/product.service';
import { SubCategory } from 'src/app/cards/subcategory/subCategory.model';
import { SubcategoryService } from 'src/app/cards/subcategory/subcategory.service';
import { Globle } from 'src/assets/globle';
import { ExportexcelService } from '../exportexcel.service';
import { OrderByProduct } from '../orderbyproduct.model';
import { ReportsService } from '../reports.service';

@Component({
  selector: 'app-ordersbyproduct',
  templateUrl: './ordersbyproduct.component.html',
  styleUrls: ['./ordersbyproduct.component.css']
})
export class OrdersbyproductComponent implements OnInit {

  reports: OrderByProduct[] = [];

  subCategories: SubCategory[] = [];
  category: Category[] = [];
  products: Product[] = [];
  displayedColumns: string[] = ['date', 'quantity', "total", "CardsNumber", "orderId"];
  dataSource!: MatTableDataSource<OrderByProduct>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  spinnerOverlay = false;
  selectedCategory!: number;
  selectedSubCategory!: number;
  selectedProduct!: number;
  lang = 'en';
  reportObj: OrderByProduct = {} as OrderByProduct;
  directCharged = false;
  pageSize = 100;
  constructor(private service: ReportsService,
    private categoryService: CategoryService,
    private subCategoryService: SubcategoryService,
    private productService: ProductService,
    private translate: TranslateService,
    private excelService: ExportexcelService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getCategory();
  }

  getCategory() {
    this.categoryService.getAll(1, this.directCharged).subscribe(data => {
      this.category = data;
    }, error => {
      console.log(error)
    })
  }

  getSubCategory() {
    this.subCategoryService.getAll(this.selectedCategory, 1).subscribe(data => {
      this.subCategories = data
    }, error => {
      console.log(error)
    });
  }

  getProduct() {
    this.productService.getAll(this.selectedSubCategory, 1).subscribe(data => {
      this.products = data
    }, error => {
      console.log(error)
    })
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAllByProduct(this.selectedProduct, this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {
      let obj = data

      this.reports = data;
      // if (obj.length > 0) {

      //   for (let i = 0; i < obj.length; i++) {
      //     this.reportObj = {} as OrderByProduct;
      //     this.reportObj.total = obj[i]['total'];
      //     this.reportObj.quantity = obj[i]['quantity'];

      //     var date = new Date(obj[i]['date']);
      //     this.reportObj.date = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes();
      //     this.reports.push(this.reportObj);
      //   }
      // }
      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  getTotalCost() {
    return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف فئة فرعية ", 90, 10);
    doc.text("_________________________________", 50, 12);

    // set font
    doc.setFontSize(10);
    doc.viewerPreferences({ "Direction": "L2R" }, true);

    doc.text(" الفئة الرئيسية : " + this.category.find(x => x.id == this.selectedCategory)?.arabicName, 150, 20, {
      isOutputRtl: true,
    });

    doc.text(" الفئة الفرعيه : " + this.subCategories.find(x => x.id == this.selectedSubCategory)?.arabicName, 120, 20, {
      isOutputRtl: true,
    });

    doc.text(" المنتج : " + this.products.find(x => x.id == this.selectedProduct)?.arabicName, 100, 20, {
      isOutputRtl: true,
    });

    if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
      && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
      doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
        isOutputRtl: true
      });
      doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
        isOutputRtl: true
      });
    }

    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#productTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }

  onCategoryChange() {
    this.getSubCategory();
  }

  onsubCategoryChange() {
    this.getProduct();
  }

  exportAsXLSX(): void {
    var exportList = [];
    for (let i = 0; i < this.reports.length; i++) {
      var productCards = "";
      this.reports[i].productCards.forEach((item: any) => {
        productCards += item
      })
      var obj = {
        "التاريخ": this.reports[i].date,
        "الكمية": this.reports[i].quantity,
        "المجموع": this.reports[i].total,
        "ارقام البطاقات": productCards
      }

      exportList.push(obj);
    }
    this.excelService.exportAsExcelFile(exportList, 'تقرير مبيعات منتج');
  }


}
